export default {
    limitInputLength(input, maxLength) {
        if (input.length > maxLength) {
            input = input.slice(0, maxLength)
        }
        return input
    }
}
